import { CalEventFieldType } from '../constants/cal-event-field-type.js';
import { hasAtMostDecimals } from './has-at-most-decimals.js';
import { isBlankFieldValue } from './is-blank-field-value.js';
import { isCalendarDateString } from './is-calendar-date-string.js';
import { TEMPLATE_NUMBER_DECIMALS } from './template-number-decimals.js';
import { TEMPLATE_NUMBER_LIMIT } from './template-number-limit.js';
/** Checks a non-blank value against its field's config; blank values are the required check's concern. */
export function validateTemplateFieldValue(typeId, config, value) {
    if (isBlankFieldValue(value))
        return undefined;
    switch (typeId) {
        case CalEventFieldType.TEXT: {
            const { maxLength } = config;
            if (typeof value !== 'string')
                return 'Enter text.';
            if (maxLength !== undefined && value.trim().length > maxLength)
                return `Must be ${maxLength} characters or fewer.`;
            return undefined;
        }
        case CalEventFieldType.NUMBER: {
            const { min, max, integer, currency } = config;
            if (typeof value !== 'number' || Number.isNaN(value))
                return 'Enter a number.';
            if (Math.abs(value) >= TEMPLATE_NUMBER_LIMIT) {
                return value < 0 ? 'Enter a larger number.' : 'Enter a smaller number.';
            }
            if (integer && !Number.isInteger(value))
                return 'Enter a whole number.';
            if (currency && !hasAtMostDecimals(value, 2))
                return 'Enter an amount with at most two decimals.';
            if (!hasAtMostDecimals(value, TEMPLATE_NUMBER_DECIMALS))
                return `Enter a number with at most ${TEMPLATE_NUMBER_DECIMALS} decimals.`;
            if (min !== undefined && value < min)
                return `Must be at least ${min}.`;
            if (max !== undefined && value > max)
                return `Must be at most ${max}.`;
            return undefined;
        }
        case CalEventFieldType.SELECT: {
            const { options = [] } = config;
            return typeof value === 'string' && options.includes(value)
                ? undefined
                : 'Choose one of the listed options.';
        }
        case CalEventFieldType.DATE:
            return isCalendarDateString(value) ? undefined : 'Enter a valid date.';
        case CalEventFieldType.ENTITY_REF:
            return typeof value === 'string' ? undefined : 'Choose a record.';
        case CalEventFieldType.SYSTEM_TIMESTAMP:
            return 'This field is set by the system.';
        case CalEventFieldType.PER_PRODUCT_NUMBER:
            return 'A per-product field has no event-level value.';
        default:
            return undefined;
    }
}
//# sourceMappingURL=validate-template-field-value.js.map